import React from 'react';
import { ComponentMeta, ComponentStory } from '@storybook/react';

import FieldSet from './FieldSet';
import Input from '../Input';
import ToggleSwitch from '../ToggleSwitch';
import InputArea from '../InputArea';

export default {
  title: 'FieldSet',
  component: FieldSet,
} as ComponentMeta<typeof FieldSet>;

const Template: ComponentStory<typeof FieldSet> = args => (
  <div style={{ width: '500px' }}>
    <FieldSet {...args} />
  </div>
);

const commonProps = {
  children: [<Input />, <ToggleSwitch checked />, <InputArea />],
};

export const Basic = Template.bind({});
Basic.args = {
  ...commonProps,
  legend: 'Basic FieldSet',
};
